module.exports = __webpack_public_path__ + "img/left.5ca982f6.png";